histories-task-updated
  span.event {this.locale().event}
  span.updated
    histories-updated-polymorphic.responsible_id(if="{opts.json.responsible_id != undefined}" tag-scope="{this.tagScope}" scope="responsible_id" scope2="responsible_type" locale="{locale()}" getter="{responsibleName}" label-style="background: {phaseColorCode()}")
    histories-updated.memo(if="{opts.json.memo != undefined}" tag-scope="{this.tagScope}" scope="memo" locale="{locale()}" getter="{straight}" label-style="background: {phaseColorCode()}")
  script(type="typescript").
    this.mixin('histories.base');
